package com.example.mystybag.core.expected

actual object Connection {
    actual fun addInternetConnectionListener(onOnline: (Boolean) -> Unit) {}
    actual fun removeInternetConnectionListener() {}
}
